<template>
  <el-descriptions :column="1" border style="width: 100%">
    <el-descriptions-item label="客户名称">
      {{ detail.Client }}
    </el-descriptions-item>
    <el-descriptions-item label="联系地址">
      {{ detail.Address }}
    </el-descriptions-item>
    <el-descriptions-item label="联系人">
      {{ detail.Linkman }} {{ detail.Linktel }}
    </el-descriptions-item>
    <el-descriptions-item label="任务内容">
      {{ $utils.meta.format("schedule-type", detail.Type) }}
      {{ detail.Request }}
    </el-descriptions-item>
    <el-descriptions-item label="计划时间" v-if="detail?.PlanTime">
      {{ $utils.common.parseTime(detail.PlanTime, "{y}-{m}-{d} {h}:{i}") }}
    </el-descriptions-item>
    <el-descriptions-item label="任务负责人">
      {{ detail.Operator.Dept + "_" + detail.Operator.Name }}
    </el-descriptions-item>
    <el-descriptions-item label="处理结果">
      <template v-if="detail.Target">
        {{ detail?.Result || "请进入对应业务处理..." }}
      </template>
      <el-input v-model="detail.Result" v-else-if="detail.State == 0" />
      <span v-else>{{ detail.Result }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="相关文件">
      <uploader ref="uploader" :data="{ Mode: 'schedule', ObjectId: detail.Id }" multiple :auto-upload="false"
        :disabled="detail.State != 0 || detail.Target" accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">
          选择上传
        </el-link>
      </uploader>
    </el-descriptions-item>
    <el-descriptions-item label="完成时间" v-if="detail?.ExecTime">
      {{ $utils.common.parseTime(detail.ExecTime, "{y}-{m}-{d} {h}:{i}") }}
    </el-descriptions-item>

    <el-descriptions-item v-if="detail.State == 0 && !detail.Target">
      <el-button type="primary" @click="onSubmit" v-loading.fullscreen.lock="loading">
        处理完成
      </el-button>
      <el-button type="danger" @click="onCancel" v-loading.fullscreen.lock="loading">
        撤销任务
      </el-button>
    </el-descriptions-item>
  </el-descriptions>
</template>


<script>
export default {
  props: {
    id: { type: String },
    layerid: { type: String },
  },
  data() {
    return {
      detail: null,
    };
  },
  components: {
    uploader: () => import("@/views/system/file/multipleUpload"),
  },
  created() {
    this.$apis.job.schedule.info({ id: this.id }).then((res) => {
      this.detail = res;
    });
  },
  methods: {
    //作废任务
    onCancel() {
      this.$confirm(`取消任务后将不做工作考核, 是否继续?`, "撤销", {
        center: true,
      }).then(() => {
        this.$apis.job.schedule
          .cancel({ id: this.detail.Id })
          .then(() => {
            this.$message({ message: "已撤销任务", type: "success" });
            this.$layer.close(this.layerid);
            this.$parent.loadData();
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
    //提交数据
    onSubmit() {
      this.loading = true;
      this.$apis.job.schedule
        .complete(this.detail)
        .then(() => {
          return this.$refs.uploader.onSubmit();
        })
        .then(() => {
          this.$parent.loadData();
          this.$layer.close(this.layerid);
        })
        .catch((e) => {
          this.$message.error(e || "执行错误");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-descriptions) {
  &-item__label {
    width: 120px;
  }
}
</style>